"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("./../type/entity");
function getRegisterType(command, user) {
    const { creatorId: actorId, waitList, joinWaitList } = command;
    const { userId } = user;
    if (actorId === userId) {
        if (waitList || joinWaitList) {
            return entity_1.ILTRegisterType.WAITLISTED;
        }
        return entity_1.ILTRegisterType.ENROLLED;
    }
    else {
        return entity_1.ILTRegisterType.ASSIGNED;
    }
}
exports.getRegisterType = getRegisterType;
//# sourceMappingURL=getRegisterType.js.map